import {isJwtExpired} from 'jwt-check-expiration';
import Config from '../../Config';
import LocalData from '../../helpers/local-data';
import { checkAuthTokenUseCase } from '../../helpers/auth-token';

class Auth {
    login(cb) {
        const token = LocalData.get(Config.LOCAL_DATA_KEYS.JWT_ACCESS_TOKEN);
        if (token && !isJwtExpired(token)) {
            cb();
        }
    }

    logout(cb) {
        // Clear application tokens
        LocalData.remove(Config.LOCAL_DATA_KEYS.JWT_ACCESS_TOKEN);
        LocalData.remove(Config.LOCAL_DATA_KEYS.ACCESS_TOKEN);
        
        // Clear all localStorage and sessionStorage (portal tokens)
        localStorage.clear();
        sessionStorage.clear();
        
        // Clear all cookies (portal session cookies)
        document.cookie.split(";").forEach(function(c) { 
            document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
        });
        
        // Clear cookies for different domains/paths that portal might use
        const domains = [window.location.hostname, '.hcn-inc.com', '.dinein-backend.hcn-inc.com'];
        domains.forEach(domain => {
            document.cookie.split(";").forEach(function(c) { 
                document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/;domain=" + domain); 
            });
        });
        
        cb();
    }

    isAuthenticated() {
        return checkAuthTokenUseCase();
    }
}

export default new Auth();
